/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOwnFundVariantDto } from '../../models/backend-own-fund-variant-dto';
import { BackendOwnFundVariantRequestDto } from '../../models/backend-own-fund-variant-request-dto';

export interface FinancingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded$Params {
  /**
   * A unique integer value identifying this own fund variant.
   */
  id: number;
  body: BackendOwnFundVariantRequestDto;
}

export function financingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOwnFundVariantDto>;
    }),
  );
}

financingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded.PATH = '/api/financing_sources/own_funds_variants/{id}/';
